import React from "react";
import { Graph } from "../assets/img";
import Container from "./Container";

const GraphSection = () => {
    return (
        <Container>
            <div className="py-4 overflow-auto">
                <img src={Graph} alt="" className="w-full min-w-[680px]" />
            </div>
        </Container>
    );
};

export default GraphSection;
